import { styled } from 'twin.macro'

export const MatterPortRoot = styled.iframe<{ $bigger?: boolean }>`
    height: ${({ $bigger }) => {
        return $bigger ? '40em' : '30em'
    }};
    width: 100%;
`
